import { createTheme, Theme } from '@mui/material';
import createFurtherTheme from 'further-ui/theme';

const furtherTheme = createFurtherTheme({
  whiteLabelConfig: {
    primaryColor: '#56B26C',
    primaryContrastText: '#FFFFFF',
    secondaryColor: '#2196F3',
  },
  isAdminSite: true,
});

export default createTheme(furtherTheme, {
  sidebar: {
    width: 250,
    drawerBreakpoint: 'lg',
  },
  searchBar: {
    height: 52,
  },
});

export const globalStyles = (theme: Theme) => ({
  '*': {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontSmooth: 'never',
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
  },
  '.notistack-SnackbarContainer': {
    zIndex: '10000 !important',
  },
  '.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content': {
    border: 'none !important',
  },
  '.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable), .ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable)':
    {
      minHeight: '100px',
    },
  '.ck.ck-toolbar': {
    border: `1px solid ${theme.palette.grey[300]} !important`,
    borderBottom: 'none !important',
    borderRadius: ` ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0 !important`,
    padding: `${theme.spacing(2)} ${theme.spacing(4)} 0 ${theme.spacing(
      4,
    )} !important`,
  },
  '.ck.ck-toolbar__items': {
    borderBottom: `1px solid ${theme.palette.grey[300]} !important`,
    paddingBottom: `${theme.spacing(2)} !important`,
  },
  '.ck.ck-editor__editable_inline': {
    border: `1px solid ${theme.palette.grey[300]} !important`,
    borderTop: 'none !important',
    borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px !important`,
    padding: `${theme.spacing(2)} ${theme.spacing(4)} !important`,
    fontSize: theme.typography.body2.fontSize,
  },

  '.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable)': {
    // border: `1px solid ${theme.palette.grey[300]} !important`,
    boxShadow: `0px 0px 0px !important`,
  },
  '.ck-content.text-component p + p': {
    marginTop: theme.spacing(1),
  },
  '.ck-content.text-component p': {
    margin: 0,
  },
  '.ck-content p': {
    marginBottom: theme.spacing(1),
  },
});
